import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useDOPRouter } from '@/globals/routing/DOPRouter';
import { QuestionTranslation, questionTranslations } from './legalForm.config';
import { useQuestionIndexContext } from './useQuestionIndex';
const getAnswer = (queryValue: string | null, allowedAnswers: QuestionTranslation['answers']) => {
  switch (queryValue) {
    case '':
      return '';
    // skipped
    case null:
      return null;
    // unanswered
    default:
      return allowedAnswers.some(answer => {
        return answer.id === queryValue;
      }) ? queryValue : null;
  }
};

/**
 * Get all the user's answers from the URL search parameters.
 */
export const useGivenAnswers = () => {
  const $ = _c(2);
  const searchParams = useSearchParams();
  let answers;
  if ($[0] !== searchParams) {
    answers = new Map();
    for (const question of questionTranslations) {
      const queryValue = searchParams.get(question.id);
      const answer = getAnswer(queryValue, question.answers);
      answers.set(question.id, answer);
    }
    $[0] = searchParams;
    $[1] = answers;
  } else {
    answers = $[1];
  }
  return answers;
};
export const useGivenAnswer = questionId => {
  const $ = _c(10);
  const router = useDOPRouter();
  const searchParams = useSearchParams();
  const givenAnswers = useGivenAnswers();
  let t0;
  if ($[0] !== questionId || $[1] !== router || $[2] !== searchParams) {
    t0 = value => {
      const newSearchParams = new URLSearchParams(searchParams.toString());
      newSearchParams.set(questionId, value);
      router.replaceClient(`?${newSearchParams.toString()}`);
    };
    $[0] = questionId;
    $[1] = router;
    $[2] = searchParams;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  const setGivenAnswer = t0;
  let t1;
  if ($[4] !== givenAnswers || $[5] !== questionId) {
    t1 = givenAnswers.get(questionId);
    $[4] = givenAnswers;
    $[5] = questionId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== setGivenAnswer || $[8] !== t1) {
    t2 = [t1, setGivenAnswer];
    $[7] = setGivenAnswer;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2 as const;
};

/**
 * Get the question the user is currently editing.
 * If a specific question is being edited, returns that question.
 * If no question is being edited, returns the first unanswered question.
 * If all questions are answered and no question is being edited, returns `null` as question - we should be in 'results' view.
 */
export const useCurrentQuestion = () => {
  const [t0] = useQuestionIndexContext();
  const {
    index: questionIndex
  } = t0;
  const givenAnswers = useGivenAnswers();
  if (questionIndex != null) {
    const question = questionTranslations[questionIndex];
    if (question != null) {
      return question;
    }
  }
  const newIndex = [...givenAnswers.values()].findIndex(_temp);
  return questionTranslations[newIndex];
};
function _temp(v) {
  return v === null;
}